module.exports = "<div class=\"restrict-mbl\">\n<!-- <h1> Important </h1> -->\n<p>Sorry for the inconvenience.<br> Please access the web panel from the laptop or desktop </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/restrict-mobile/restrict-mobile.component.html
// module id = ./src/app/restrict-mobile/restrict-mobile.component.html
// module chunks = main